import {
  type AdAssetProps,
  AdAsset,
} from "src/pages/ad-studio/components/ad-asset";
import type { AdStudioTemplateCard } from "src/pages/ad-studio/templates/types";
import { useFilledTemplateHtml } from "src/pages/ad-studio/templates/use-filled-template-html";

type Props = Pick<
  AdAssetProps,
  "width" | "height" | "naturalWidth" | "naturalHeight"
> & {
  template: AdStudioTemplateCard;
};

/** Shared preview of saved template markup filled with its authored sample values. */
export function AdStudioTemplatePreview({
  template,
  width = "100%",
  height = "100%",
  naturalWidth,
  naturalHeight,
}: Props) {
  const { html, assets } = useFilledTemplateHtml(template.content);
  if (!html) return null;

  return (
    <AdAsset
      src=""
      decorative
      svg={html}
      componentAssets={assets}
      width={width}
      height={height}
      naturalWidth={naturalWidth}
      naturalHeight={naturalHeight}
      objectFit="contain"
    />
  );
}
